import { MutableRefObject, useEffect, useState } from 'react';

export function useBottomDistance(ref: MutableRefObject<HTMLElement>, defaultHeight = 0) {
  const [bottomDistance, setBottomDistance] = useState(defaultHeight);
  useEffect(() => {
    setBottomDistance(window.innerHeight - (ref?.current?.getBoundingClientRect?.()?.bottom || 0));
  }, []);
  return bottomDistance;
}
